import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  showBottomSheet: BehaviorSubject<boolean>;
  headerTitle: BehaviorSubject<string>;

  constructor() {
    this.showBottomSheet = new BehaviorSubject<boolean>(false);
    this.headerTitle = new BehaviorSubject<string>('');
  }

  setShowBottomSheet(state: boolean) {
    this.showBottomSheet.next(state);
  }

  setHeaderTitle(title: string) {
    this.headerTitle.next(title);
  }

  observerShowBottomSheet() {
    return this.showBottomSheet.asObservable();
  }

  observeHeaderTitle() {
    return this.headerTitle.asObservable();
  }
}
